import { render, staticRenderFns } from "./OrderInfoItem.vue?vue&type=template&id=46563c2e&scoped=true"
import script from "./OrderInfoItem.vue?vue&type=script&lang=js"
export * from "./OrderInfoItem.vue?vue&type=script&lang=js"
import style0 from "./OrderInfoItem.vue?vue&type=style&index=0&id=46563c2e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46563c2e",
  null
  
)

export default component.exports